import { useAuth0 } from '@auth0/auth0-react';
import { Dispatch, SetStateAction, useState } from 'react';
import { Popover } from '@mui/material';
import CustomButton from '../reusable/CustomButton';
import { DATA_QC_SCHOOL_LOCAL_STORAGE_KEY } from '../../constants';
import { invalidateSessionAndMfa } from '../../services/userService';

interface UserProfilePopoverProps {
  anchorEl: HTMLButtonElement | null;
  handleIsProfileMenuOpen: Dispatch<SetStateAction<boolean>>;
}

const UserProfilePopover = ({ anchorEl, handleIsProfileMenuOpen }: UserProfilePopoverProps) => {
  const { logout, getAccessTokenSilently } = useAuth0();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const handleClose = () => {
    handleIsProfileMenuOpen(false);
  };

  const handleLogOut = async () => {
    setIsLoggingOut(true);
    try {
      const accessToken = await getAccessTokenSilently();
      await invalidateSessionAndMfa(accessToken);
    } catch (error) {
      console.error('Failed to invalidate session/MFA on backend:', error);
    }
    localStorage.removeItem(DATA_QC_SCHOOL_LOCAL_STORAGE_KEY);
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <>
      <Popover
        open={true}
        onClose={handleClose}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        slotProps={{
          paper: {
            sx: { width: anchorEl ? anchorEl.clientWidth : undefined },
          },
        }}
      >
        {/* <CustomButton
        className="user-profile-popover-button"
        variant="clear"
        buttonText="Settings"
        buttonAction={() => {}}
        sx={{
          padding: 'var(--scaling-spacing-8)',
          display: 'block',
          textAlign: 'left',
          fontSize: 'var(--font-size-14)'
        }}
      /> */}
        <CustomButton
          className="user-profile-popover-button"
          variant="clear"
          buttonText={isLoggingOut ? 'Signing Out...' : 'Sign Out'}
          buttonAction={handleLogOut}
          disabled={isLoggingOut}
          sx={{
            padding: 'var(--scaling-spacing-8)',
            display: 'block',
            textAlign: 'left',
            fontSize: 'var(--font-size-14)',
          }}
        />
      </Popover>
    </>
  );
};

export default UserProfilePopover;
